import { render, staticRenderFns } from "./AlertTypeList.vue?vue&type=template&id=3e33b10e&scoped=true"
import script from "./AlertTypeList.vue?vue&type=script&lang=js"
export * from "./AlertTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e33b10e",
  null
  
)

export default component.exports